import { render } from "./ChooseItemsModal.vue?vue&type=template&id=5e50b887&scoped=true"
import script from "./ChooseItemsModal.vue?vue&type=script&lang=ts"
export * from "./ChooseItemsModal.vue?vue&type=script&lang=ts"

import "./ChooseItemsModal.vue?vue&type=style&index=0&id=5e50b887&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5e50b887"

export default script